import "./personality-distribution.css";

// Short Report: Personality Distribution
const PersonalityDistributionReport = (comparisonResult) => {
  console.log("Comparison Result:", comparisonResult);
  // const comparisonResult = {
  //   summary: {
  //     entitiesCompared: 2,
  //     team1HighestSkill: "Professional Focus",
  //     team2HighestSkill: "Spirit & Reward",
  //   },
  //   metrics: [
  //     {
  //       name: "Avg. Spirit Score of Team 1",
  //       type: "Product Development",
  //       performance: 50, // avg 5 out of 10 = 50%
  //     },
  //     {
  //       name: "Avg. Spirit Score of Team 2",
  //       type: "Product Management",
  //       performance: 80, // avg 8 out of 10 = 80%
  //     },
  //     {
  //       name: "Avg. Reward Score of Team 1",
  //       type: "Product Development",
  //       performance: 30, // avg 3 out of 10 = 30%
  //     },
  //     {
  //       name: "Avg. Reward Score of Team 2",
  //       type: "Product Management",
  //       performance: 80, // avg 8 out of 10 = 80%
  //     },
  //     {
  //       name: "Avg. Professional Score of Team 1",
  //       type: "Product Development",
  //       performance: 60, // avg 6 out of 10 = 60%
  //     },
  //     {
  //       name: "Avg. Professional Score of Team 2",
  //       type: "Product Management",
  //       performance: 90, // avg 9 out of 10 = 90%
  //     },
  //     {
  //       name: "Avg. Purpose Score of Team 1",
  //       type: "Product Development",
  //       performance: 30, // avg 3 out of 10 = 30%
  //     },
  //     {
  //       name: "Avg. Purpose Score of Team 2",
  //       type: "Product Management",
  //       performance: 70, // avg 7 out of 10 = 70%
  //     },
  //   ],
  // };

  // Split metrics into two groups for the two progress bar sections
  // const team1Metrics = comparisonResult?.metrics?.filter(
  //   (_, index) => index % 2 === 0
  // );
  // const team2Metrics = comparisonResult?.metrics?.filter(
  //   (_, index) => index % 2 === 1
  // );

  return (
    <div className="tt-pd-short-report-container">
      <div className="tt-pd-report-header">
        <h3>Personality Distribution</h3>
        <p>Quick overview of personality traits between the selected teams</p>
      </div>

      {/* Summary Cards */}
      <div className="tt-pd-comparison-summary">
        <div className="tt-pd-summary-card">
          <div className="tt-pd-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="tt-pd-summary-content">
            <div className="tt-pd-summary-value">
              2{/* {comparisonResult.summary.entitiesCompared} */}
            </div>
            <div className="tt-pd-summary-label">Entities Compared</div>
          </div>
        </div>

        <div className="tt-pd-summary-card">
          <div className="tt-pd-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-pd-summary-content">
            <div className="tt-pd-summary-value">
              {/* {comparisonResult.summary.team1HighestSkill} */}
              {
                comparisonResult?.comparisonData
                  ?.personalityDistributionShortReport.teamAHighestAvgAptitude
                  ?.aptitude
              }
            </div>
            <div className="tt-pd-summary-label">
              Skill with Highest Avg. in{" "}
              {
                comparisonResult?.comparisonData?.detailedReport.teamADetails
                  ?.teamName
              }
            </div>
          </div>
        </div>

        <div className="tt-pd-summary-card">
          <div className="tt-pd-summary-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M11.562 3.266a.5.5 0 0 1 .876 0L14.5 8.5l5.5.5a.5.5 0 0 1 .281.85L16 14l1 5.5a.5.5 0 0 1-.766.44L12 17l-4.234 2.94a.5.5 0 0 1-.766-.44L8 14l-4.281-4.15a.5.5 0 0 1 .281-.85L9.5 8.5l2.062-5.234Z" />
            </svg>
          </div>
          <div className="tt-pd-summary-content">
            <div className="tt-pd-summary-value">
              {/* {
                comparisonResult?.comparisonData?.teamBDetails
                  ?.highestAvgAptitude?.key
              } */}
              {
                comparisonResult?.comparisonData
                  ?.personalityDistributionShortReport.teamBHighestAvgAptitude
                  ?.aptitude
              }
            </div>
            <div className="tt-pd-summary-label">
              Skill with Highest Avg. in{" "}
              {
                comparisonResult?.comparisonData?.detailedReport?.teamBDetails
                  ?.teamName
              }
            </div>
          </div>
        </div>
      </div>

      {/* Team 1 Personality Metrics */}
      <div className="tt-pd-metrics-comparison">
        <h3>
          Average Scores of Each Aptitude Skill in 
          {
            comparisonResult?.comparisonData?.detailedReport.teamADetails
              ?.teamName
          }
          {/* {comparisonResult?.comparisonData?.teamADetails?.teamName} */}
        </h3>
        <div className="tt-pd-metrics-chart">
          {comparisonResult?.comparisonData?.personalityDistributionShortReport.avgTeamAptitudeScores.map(
            (metric, index) => (
              <div key={index} className="tt-pd-metric-bar-container">
                <div className="tt-pd-metric-info">
                  <span className="tt-pd-metric-name">{metric?.aptitude}</span>
                  {/* <span className="tt-pd-metric-type">{metric.type}</span> */}
                </div>
                <div className="tt-pd-metric-bar">
                  <div
                    className="tt-pd-metric-fill"
                    style={{ width: `${Math.round(metric?.avgScore * 10)}%` }}
                  ></div>
                  <span className="tt-pd-metric-value">
                    {Math.round(metric?.avgScore * 10)}%
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* Team 2 Personality Metrics */}
      <div className="tt-pd-metrics-comparison">
        <h3>
          Average Scores of Each Aptitude Skill in{" "}
          {
            comparisonResult?.comparisonData?.detailedReport.teamBDetails
              ?.teamName
          }
          {/* {comparisonResult?.comparisonData?.teamBDetails?.teamName} */}
        </h3>
        <div className="tt-pd-metrics-chart">
          {comparisonResult?.comparisonData?.personalityDistributionShortReport.avgTeamBAptitudeScores.map(
            // {comparisonResult?.comparisonData?.teamBDetails?.avgAptitudeScores?.map(
            (metric, index) => (
              <div key={index} className="tt-pd-metric-bar-container">
                <div className="tt-pd-metric-info">
                  <span className="tt-pd-metric-name">{metric?.aptitude}</span>
                  {/* <span className="tt-pd-metric-type">{metric.type}</span> */}
                </div>
                <div className="tt-pd-metric-bar">
                  <div
                    className="tt-pd-metric-fill"
                    style={{ width: `${Math.round(metric?.avgScore * 10)}%` }}
                  ></div>
                  <span className="tt-pd-metric-value">
                    {Math.round(metric?.avgScore * 10)}%
                  </span>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="tt-pd-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-pd-analysis-paragraph">
          <p>
            {
              comparisonResult?.comparisonData?.personalityDistributionShortReport?.overview
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default PersonalityDistributionReport;
